"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgSupport48 = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg", role: "img" }, props, { children: (0, jsx_runtime_1.jsxs)("g", __assign({ fill: "none", fillRule: "evenodd" }, { children: [(0, jsx_runtime_1.jsx)("path", { fill: "none", d: "M0 .5h48v48H0z" }), (0, jsx_runtime_1.jsx)("path", { d: "M27.9 27.262v3.126m-7.8 0v-3.126m-5.25-8.355c0-5.018 4.105-9.1 9.15-9.1s9.15 4.082 9.15 9.1M10.11 39.193c0-4.174 4.23-7.697 10.015-8.804m7.746 0c5.68 1.085 9.86 4.498 10.014 8.571l.005.233M20.1 30.388c0 1.105 1.746 2 3.9 2s3.9-.895 3.9-2m-4.01-3.655h4.62a4.14 4.14 0 0 0 4.14-4.14m-8.76 3.72h2M14 18.593h3v4h-3v-4Zm10 10.353c-2.928 0-7-3.66-7-7.603v-2.6c0-3.942 3.14-7.15 7-7.15s7 3.208 7 7.15v2.6c0 3.943-4.072 7.603-7 7.603Zm7-10.353h3v4h-3v-4Z", stroke: "currentColor" })] })) }))); };
exports.default = SvgSupport48;
